import React, { useState } from "react";
import "../../styles/image-upload-modal.css";

const ImageUploadModal = ({ isOpen, onClose, onUpload }) => {
  const [imageUrl, setImageUrl] = useState("");
  const [file, setFile] = useState(null);
  const [altText, setAltText] = useState("");
  const [uploadMethod, setUploadMethod] = useState("file");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    // console.log(selectedFile, "check selectedFile");

    if (selectedFile) {
      setFile(selectedFile);
      setError("");
      // Preview the image
      // console.log(URL.createObjectURL(selectedFile), "check url");

      setImageUrl(URL.createObjectURL(selectedFile));
    }
  };

  // console.log("Alt text received:", altText);

  const handleSubmit = async () => {
    if (uploadMethod === "file") {
      if (!file) {
        setError("Please select a file");
        return;
      }

      try {
        setLoading(true);
        await onUpload(file, altText.trim());
        resetForm();
        onClose();
      } catch (error) {
        setLoading(false);
        console.error("Upload failed:", error);
        setError("Failed to upload image");
      } finally {
        setLoading(false);
      }
    }
  };

  const resetForm = () => {
    setImageUrl("");
    setFile(null);
    setAltText("");
    setError("");
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: "500px" }}>
        <div className="modal-header">
          <h3>Insert Image</h3>
          <button
            className="close-button"
            onClick={() => {
              resetForm();
              onClose();
            }}
          >
            ×
          </button>
        </div>

        <div className="modal-body">
          <div className="upload-method-selector">
            <button
              className={`method-btn ${
                uploadMethod === "file" ? "active" : ""
              }`}
              onClick={() => {
                setUploadMethod("file");
                setError("");
              }}
            >
              Upload File
            </button>
          </div>

          <div className="file-upload">
            <label className="file-upload-label">
              <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                className="file-input"
              />
              Choose File
            </label>
            {file && (
              <div className="file-info">
                <p>
                  {file.name} ({(file.size / 1024).toFixed(1)} KB)
                </p>
                <div className="image-preview">
                  <img src={imageUrl} alt="Preview" />
                  <p className="preview-text">File Preview</p>
                </div>
              </div>
            )}
          </div>

          <div className="alt-text-input">
            <input
              type="text"
              placeholder="Alt text (optional - describes the image)"
              value={altText}
              onChange={(e) => setAltText(e.target.value)}
            />
          </div>
        </div>

        <div className="modal-footer">
          <button
            className="cancel-btn"
            onClick={() => {
              resetForm();
              onClose();
            }}
          >
            Cancel
          </button>
          <button
            className="insert-btn"
            onClick={handleSubmit}
            disabled={loading || (uploadMethod === "file" && (!file || error))}
          >
            Insert Image
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImageUploadModal;
